export enum ContactDetailType {
  email = 'email',
  phone = 'phone',
}

export type ContactDetail = {
  type: ContactDetailType;
  hint: string;
};
